import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';

@Component({
  selector: 'app-badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.scss'],
})
export class BadgeComponent implements OnInit, OnChanges {
  constructor() {}

  @Input() approval: UserApprovalResponse = undefined;

  label: string = '';
  badgeClass: string = '';

  ngOnInit(): void {}
  
  ngOnChanges(changes: SimpleChanges) {
    if (this.approval) {
      this.updateStatus();
    }
  }

  /**
   * Atualiza o status e a classe do badge seguindo o mesmo padrão da listagem
   */
  private updateStatus(): void {
    // Prioridade 1: Se tiver current_stage no register, usa diretamente
    if (this.approval.register?.current_stage) {
      const currentStage = this.approval.register.current_stage;
      
      // Normalizar os valores
      if (currentStage === 'Em edição' || currentStage === 'Em edicao') {
        this.label = 'Em edição';
        this.badgeClass = 'status-badge-editing';
        return;
      }
      if (currentStage === 'Em aprovação' || currentStage === 'Em aprovacao') {
        this.label = 'Em aprovação';
        this.badgeClass = 'status-badge-approval';
        return;
      }
      if (currentStage === 'Homologado' || currentStage === 'Aprovado' || currentStage === 'Concluído') {
        this.label = 'Homologado';
        this.badgeClass = 'status-badge-homologated';
        return;
      }
      if (currentStage === 'Rejeitado') {
        this.label = 'Rejeitado';
        this.badgeClass = 'status-badge-rejected';
        return;
      }
      
      // Se não corresponder a nenhum padrão conhecido, usa o valor original
      this.label = currentStage;
      this.badgeClass = 'status-badge-editing';
      return;
    }

    // Prioridade 2: Fallback para lógica antiga baseada no approval
    if (this.approval.completed) {
      if (this.approval.is_approved) {
        this.label = 'Homologado';
        this.badgeClass = 'status-badge-homologated';
        return;
      } else {
        this.label = 'Rejeitado';
        this.badgeClass = 'status-badge-rejected';
        return;
      }
    }

    // Se está em edição (step === 0) ou editing === true
    if (this.approval.step === 0 || this.approval.editing) {
      this.label = 'Em edição';
      this.badgeClass = 'status-badge-editing';
      return;
    }

    // Caso contrário, está em aprovação
    this.label = 'Em aprovação';
    this.badgeClass = 'status-badge-approval';
  }

  /**
   * Retorna a classe CSS do badge
   */
  getBadgeClass(): string {
    return this.badgeClass;
  }
}
